import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { IconButton } from '@material-ui/core';
import { ChevronLeft, ChevronRight } from '@material-ui/icons';

const S = {
  Wrapper: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: ${({ theme }) => theme.typography.pxToRem(13)};
  `,
  IconButton: styled(IconButton)`
    padding: 0;
  `,
  ChevronLeft: styled(ChevronLeft)`
    color: ${({ theme }) => theme.palette.grey[400]};
    font-size: 1.5rem;
  `,
  ChevronRight: styled(ChevronRight)`
    color: ${({ theme }) => theme.palette.grey[400]};
    font-size: 1.5rem;
  `,
  Label: styled.label`
    margin: 0 8px;
  `,
  Input: styled.input`
    width: 48px;
    height: 24px;
    color: ${({ theme }) => theme.palette.grey[800]};
    text-align: center;
    outline: none;
    -moz-appearance: textfield;
    ::-webkit-outer-spin-button, ::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    :focus, :hover {
      border-color: ${({ theme }) => theme.palette.primary.main};
    }
  `,
  Splitter: styled.span`
    margin: 0 8px;
  `,
};

const IndividualPagination = ({
  recordCount, value, moveToPrevPage, moveToNextPage, onBlur, onChange, onKeyDown,
}) => (
  <S.Wrapper>
    <S.IconButton size="small" onClick={moveToPrevPage}>
      <S.ChevronLeft />
    </S.IconButton>
    <S.Label htmlFor="page-number">
      <S.Input
        id="page-number"
        type="number"
        value={value}
        onBlur={onBlur}
        onChange={onChange}
        onKeyDown={onKeyDown}
      />
      <S.Splitter>/</S.Splitter>
      <span>{recordCount}</span>
    </S.Label>
    <S.IconButton size="small" onClick={moveToNextPage}>
      <S.ChevronRight />
    </S.IconButton>
  </S.Wrapper>
);

IndividualPagination.propTypes = {
  recordCount: PropTypes.number,
  value: PropTypes.string.isRequired,
  moveToPrevPage: PropTypes.func.isRequired,
  moveToNextPage: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
};

IndividualPagination.defaultProps = {
  recordCount: 0,
};

export default IndividualPagination;
